export default __webpack_public_path__ + "static/media/tracking.6a605946.svg";